import contentSlice from './content/slice';
import contextSlice from './context/slice';
import databasesSlice from './databases/slice';
import datasourcesSlice from './datasources/slice';
import jiraSlice from './jira/slice';
import spacesSlice from './spaces/slice';
import usersSlice from './users/slice';

export const commonReducers = {
  content: contentSlice.reducer,
  context: contextSlice.reducer,
  databases: databasesSlice.reducer,
  jira: jiraSlice.reducer,
  spaces: spacesSlice.reducer,
  users: usersSlice.reducer,
  datasources: datasourcesSlice.reducer
};
